import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { Address } from '../shared/model/authentication/account.model';
import { AccountService } from '../shared/service/account/account.service';
import { DispensaryService } from './service/dispensary/dispensary.service';

@Injectable({
    providedIn: 'root'
  })
  export class ModelStore {

    private _addresses = new BehaviorSubject<Address[]>([]);
    addressesObservable = this._addresses.asObservable();

    private _supportedLocations = new BehaviorSubject<any[]>([]);
    supportedLocationsObservable = this._supportedLocations.asObservable();

    private _dispensary = new ReplaySubject<any>(1);
    dispensaryObservable = this._dispensary.asObservable();

    constructor(
        private accountService: AccountService,
        private dispensaryService: DispensaryService){}

    async postDispensary(dispensary: any){
        this._dispensary.next(dispensary);
    }

    async getSupportedLocations(dispId: string){
        const rs = await this.dispensaryService.getSupportedLocations(dispId).toPromise();
        this._supportedLocations.next(rs['supported_locations']);
    }

    async saveAddress(address: Address, success: () => void, error: (errorMessage: string) => void){
        const rs = await this.accountService.addUserAddress(address).toPromise();
        this.handleAddressResponse(rs, success, error);
    }

    async getAddresses(userId: number, error: (errorMessage: string) => void) {
        const rs = await this.accountService.getUserAddresses(userId).toPromise();
        this.handleAddressResponse(rs, null, error);
    }

    async deleteAddress(addressId: number, error: (errorMessage: string) => void){
        const rs = await this.accountService.deleteAddress(addressId).toPromise();
        this.handleAddressResponse(rs, null, error);
    }

    async setAddressAsDefault(addressId: number, error: (errorMessage: string) => void){
        const rs = await this.accountService.setAddressAsDefault(addressId).toPromise();
        this.handleAddressResponse(rs, null, error);
    }

    handleAddressResponse(rs: any, success: () => void, error: (errorMessage: string) => void) {
        if (rs){
            if (rs['addresses']){
                this._addresses.next(rs['addresses'].sort((a: Address, b: Address) => (a.street > b.street) ? 1 : -1));
                success && success();
            } else if (rs['code']){
                error && error("Something went wrong");
            }
        }
    }
  }